<template lang="pug">
div#home

    //- front page hero
    home-front-pages(
        ref="FrontPages"
        v-bind:svc-pages="svcPages")


    //- Articles
    home-articles.contents(
        ref="Articles"
        v-if="articles && articles.length"
        v-bind:items="articles")


    //- Events and Exhibitions
    home-events.contents(
        ref="Events"
        v-if="events && events.length"
        v-bind:items="events")


    //- Actors
    home-actors.contents(
        ref="Actors"
        v-if="actors && actors.length"
        v-bind:items="actors")


    //- Collections
    home-collections.contents(
        ref="Collections"
        v-if="collections && collections.length"
        v-bind:items="collections")


    //- Artworks
    home-artworks.contents(
        ref="Artworks"
        v-if="artworks && artworks.length"
        v-bind:items="artworks")


</template>

<script>
import MetaMixin from '@/components/Base/MetaMixin';
import SvcPagesMixin from '@/components/Base/SvcPagesMixin';

export default {
    name: 'home',

    mixins: [ MetaMixin, SvcPagesMixin ],

    components: {
        HomeFrontPages: () => import('@/components/Home/FrontPages.vue'),
        HomeCollections: () => import('@/components/Home/Collections.vue'),
        HomeArtworks: () => import('@/components/Home/Artworks.vue'),
        HomeEvents: () => import('@/components/Home/Events.vue'),
        HomeArticles: () => import('@/components/Home/Articles.vue'),
        HomeActors: () => import('@/components/Home/Actors.vue')
    },

    metaInfo: function () {
        return this.getMetaInfo({
            title: this.$site,
            titleTemplate: '%s',
            meta: [{
                property: 'og:description',
                content: this.$t('home.ingress1')
            }]
        }, this.$route);
    },

    data: function () {
        return {
            articles: [],
            events: [],
            actors: [],
            collections: [],
            artworks: [],
            error: null,
            ready: false
        };
    },

    mounted: function () {
        this.onPageAccessCheck();

        // if coming to Home from another page, splash never fires
        if (!this.ready) {
            this.init();
        }
    },

    beforeDestroy: function () {
        // reset navbar
        // this.commitNavStyle('');

        // hack: set html background color for dark theme
        if (this.$store.getters['ux/getTheme'] === 'dark') {
            document.querySelector('html').setAttribute('style', 'background: black;');
        }
    },

    watch: {
        svcPages: function () {
            this.init();
        }
    },

    methods: {
        /**
         * Init fullPage heros.
         */
        init: function () {
            if (this.svcPages.PageItems) {
                this.articles = this.svcPages.PageItems.filter(function (el) { return el.FeatureArticle; }).map(function (obj) { return obj.FeatureArticle; });
                this.events = this.svcPages.PageItems.filter(function (el) { return el.Event; }).map(function (obj) { return obj.Event; });
                this.actors = this.svcPages.PageItems.filter(function (el) { return el.Actor; }).map(function (obj) { return obj.Actor; });
                this.collections = this.svcPages.PageItems.filter(function (el) { return el.Collection; }).map(function (obj) { return obj.Collection; });
                this.artworks = this.svcPages.PageItems.filter(function (el) { return el.Artwork; }).map(function (obj) { return obj.Artwork; });
            }

            if (!this.ready) {
                this.ready = true;
                this.$nextTick(() => {
                    this.$eventBus.$emit('page-ready');
                });
            }
        },

        /**
         * Disable edit mode, emit signal to hide edit toggle in navbar.
         */
        onPageAccessCheck: function () {
            this.$eventBus.$emit('page-access-change', false, null, true);
        }
    }
};
</script>

<style lang="scss">
// specific styles in components/Home/FrontPage
// @import '~assets/styles/variables';

#home {
    width: 100vw;
    margin: 0;
    padding: 0;

    .contents {
        width: 100%;
        margin: 0;
        padding: 0 $main-content-margin 1rem;
    }
}
</style>
